import {ContextCodes} from "../../../pages/exploreHseContextsOldDeprecated/const/tabs";
import {AuthXService} from "@brg/auth";
import {AppTester} from "../../../../supporting";
import {useContextsTabs} from "../../../hooks/useContextsTabs";
import {useMemo} from "react";
import { useTranslation } from "react-i18next";

export const useGetRussianGalllleryContexts = () => {
    const { t } = useTranslation();
    const { context: currentContext } = useContextsTabs();

    const {
        REACT_APP_URL_RUSSIAN_GALLERY,
        REACT_APP_URL_GALLERY
    } = process.env
    const suffix = AuthXService.isAuthenticated() ? '?shouldForcedLogin=true&saveLoginUrl=true' : ''
    const baseURL = REACT_APP_URL_RUSSIAN_GALLERY
    const galllleryURL = REACT_APP_URL_GALLERY

    const links = useMemo(() => ([
        {
            id: ContextCodes.russianGallllery,
            active: AppTester.isBooksGallllery(),
            content: t('nav.russian_gallery.links.main'),
            linkTo: `${baseURL}`,
            action: () => {
                window.open(`${baseURL}${suffix}`, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: false,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.russianGallllery,
            active: false,
            content: t('nav.russian_gallery.links.old'),
            linkTo: `${baseURL}/old`,
            action: () => {
                window.open(`${baseURL}/old${suffix}`, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: false,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.russianGallllery,
            active: false,
            content: t('nav.russian_gallery.links.romanovs'),
            linkTo: `${baseURL}/romanovs`,
            action: () => {
                window.open(`${baseURL}/romanovs${suffix}`, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: false,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.russianGallllery,
            active: false,
            content: t('nav.russian_gallery.links.modern'),
            linkTo: `${baseURL}/modern`,
            action: () => {
                window.open(`${baseURL}/modern${suffix}`, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: false,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.russianGallllery,
            active: false,
            content: t('nav.russian_gallery.links.contemporary'),
            linkTo: `${baseURL}/contemporary`,
            action: () => {
                window.open(`${baseURL}/contemporary${suffix}`, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: false,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.russianGallllery,
            active: false,
            content: t('nav.russian_gallery.links.private_collections'),
            linkTo: `${baseURL}/tag/category/3dcd46a886cf45739a850ef7b4a6bf11`,
            action: () => {
                window.open(`${baseURL}/tag/category/3dcd46a886cf45739a850ef7b4a6bf11/${suffix}`, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: false,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.russianGallllery,
            active: false,
            content: t('nav.russian_gallery.links.timelines'),
            linkTo: `${baseURL}/timelines_russian`,
            action: () => {
                window.open(`${baseURL}/timelines_russian${suffix}`, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: false,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.galllleryMain,
            active: false,
            content: t('nav.russian_gallery.links.world_art'),
            linkTo: `${galllleryURL}`,
            action: () => {
                window.open(`${galllleryURL}/${suffix}`, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: false,
            hasCornerArrow: false,
            hidden: false,
        }
    ]), [REACT_APP_URL_RUSSIAN_GALLERY, REACT_APP_URL_GALLERY, currentContext, suffix, t])

    return {
        links,
        modalSettings: {
            titleColor: '#151514',
            title: 'russiangallllery'
        }
    }
}import {ContextCodes} from "../../../pages/exploreHseContextsOldDeprecated/const/tabs";
import {AuthXService} from "@brg/auth";
import {AppTester} from "../../../../supporting";
import {useContextsTabs} from "../../../hooks/useContextsTabs";
import {useMemo} from "react";
import { useTranslation } from "react-i18next";

export const useGetRussianGalllleryContexts = () => {
    const { t } = useTranslation();
    const { context: currentContext } = useContextsTabs();

    const {
        REACT_APP_URL_RUSSIAN_GALLERY,
        REACT_APP_URL_GALLERY
    } = process.env
    const suffix = AuthXService.isAuthenticated() ? '?shouldForcedLogin=true&saveLoginUrl=true' : ''
    const baseURL = REACT_APP_URL_RUSSIAN_GALLERY
    const galllleryURL = REACT_APP_URL_GALLERY

    const links = useMemo(() => ([
        {
            id: ContextCodes.russianGallllery,
            active: AppTester.isBooksGallllery(),
            content: t('nav.russian_gallery.links.main'),
            linkTo: `${baseURL}`,
            action: () => {
                window.open(`${baseURL}${suffix}`, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: false,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.russianGallllery,
            active: false,
            content: t('nav.russian_gallery.links.old'),
            linkTo: `${baseURL}/old`,
            action: () => {
                window.open(`${baseURL}/old${suffix}`, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: false,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.russianGallllery,
            active: false,
            content: t('nav.russian_gallery.links.romanovs'),
            linkTo: `${baseURL}/romanovs`,
            action: () => {
                window.open(`${baseURL}/romanovs${suffix}`, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: false,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.russianGallllery,
            active: false,
            content: t('nav.russian_gallery.links.modern'),
            linkTo: `${baseURL}/modern`,
            action: () => {
                window.open(`${baseURL}/modern${suffix}`, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: false,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.russianGallllery,
            active: false,
            content: t('nav.russian_gallery.links.contemporary'),
            linkTo: `${baseURL}/contemporary`,
            action: () => {
                window.open(`${baseURL}/contemporary${suffix}`, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: false,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.russianGallllery,
            active: false,
            content: t('nav.russian_gallery.links.private_collections'),
            linkTo: `${baseURL}/tag/category/3dcd46a886cf45739a850ef7b4a6bf11`,
            action: () => {
                window.open(`${baseURL}/tag/category/3dcd46a886cf45739a850ef7b4a6bf11/${suffix}`, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: false,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.russianGallllery,
            active: false,
            content: t('nav.russian_gallery.links.timelines'),
            linkTo: `${baseURL}/timelines_russian`,
            action: () => {
                window.open(`${baseURL}/timelines_russian${suffix}`, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: false,
            hasCornerArrow: false,
            hidden: false,
        },
        {
            id: ContextCodes.galllleryMain,
            active: false,
            content: t('nav.russian_gallery.links.world_art'),
            linkTo: `${galllleryURL}`,
            action: () => {
                window.open(`${galllleryURL}/${suffix}`, '_self')
            },
            target: '_self',
            level: 1,
            hasChildren: false,
            hasCornerArrow: false,
            hidden: false,
        }
    ]), [REACT_APP_URL_RUSSIAN_GALLERY, REACT_APP_URL_GALLERY, currentContext, suffix, t])

    return {
        links,
        modalSettings: {
            titleColor: '#151514',
            title: 'russiangallllery'
        }
    }
}